import React, { useRef, useEffect, useState } from "react";
import { DatePicker } from 'antd';
import "./CustomInputComponent.css";
const { RangePicker } = DatePicker;

const CustomInputComponent = ({ value, handleChange, backgroundColor, title, width, placeholder, type }) => {
    const [spanWidth, setSpanWidth] = useState(0);
    const [inputWidth, setInputWidth] = useState("auto");
    const spanRef = useRef(null);

    useEffect(() => {
        if (spanRef.current) {
            const spanWidth = spanRef.current.offsetWidth;
            const inputWidth = spanWidth > 150 ? spanWidth + 40 : "fit-content";
            setSpanWidth(spanWidth);
            setInputWidth(inputWidth);
        }
    }, [spanRef]);
   

    // Render different input components based on type
    const renderInput = () => {
        switch (type) {
            case "select":
                return (
                    <select value={value} onChange={handleChange} style={{ backgroundColor: "transparent", width: width ? `${width - (width * 0.1)}px` : '90%' }}>
                        {/* Add options here */}
                    </select>
                );
            case "date":
                return (
                    <DatePicker value={value} onChange={handleChange} style={{ width: width ? `${width - (width * 0.1)}px` : '90%' }} />
                );
            case "range":
                return (
                    <RangePicker value={value} onChange={handleChange} />
                );
            default:
                return (
                    <input type="text" value={value}  onChange={handleChange} style={{ backgroundColor: "transparent", width: width ? `${width - (width * 0.1)}px` : '90%' }} placeholder={placeholder ? placeholder : "Enter the data"} />
                );
        }
    };

    return (
        <div
            className="custom-input-component"
            style={{ backgroundColor: backgroundColor, width: width ? width : inputWidth }}
        >
            <span ref={spanRef} style={{ backgroundColor: backgroundColor }}>
                {title}
            </span>
            {renderInput()}
        </div>
    );
};

export default CustomInputComponent;
